import React, { useEffect, useState } from "react";
import styles from './EditEmailConfirmation.module.css';
import { getAppUrl } from "../../functions/getEnv";
import axios from "axios";
import setAuthToken from "../../functions/auth_header";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const EditEmailConfirmation = () => {
  const { charter_id, name, permalink, courseid, id } = useParams();
  const navigate = useNavigate();

  const appUrl = getAppUrl(import.meta.env.VITE_NODE_ENV);
 
  const [email, setEmail] = useState([]);
  const [currentEmail, setCurrentEmail] = useState('');
  const [sendToParent, setSendToParent] = useState(false);
  const [sendToStudent, setSendToStudent] = useState(false);
  const [hasExistingData, setHasExistingData] = useState(false);

 
    const fetchEmailSetup = async () => {
      try {
        if (localStorage.token) {
          setAuthToken(localStorage.token);
        }
        const response = await axios.get(
          `${appUrl}/api/leloEmailTemplate/${charter_id}/${courseid}/${id}`
        );
        
        if (response.data) {
          // Check if email is a string and convert it to array if needed
          if (response.data.email) {
            const emailArray = Array.isArray(response.data.email) 
              ? response.data.email 
              : response.data.email.split(',').map(e => e.trim());
            setEmail(emailArray);
            setHasExistingData(true);
          }
          // Set the checkbox states
          setSendToParent(response.data.pgPrimaryEmail|| false);
          setSendToStudent(response.data.studentEmail|| false);
        }
      } catch (error) {
        console.error("Error fetching template:", error);
      }
    };
   
  useEffect(() => {
    fetchEmailSetup();
  }, [charter_id, permalink, id]);

  const handleKeyDown = (e) => {
    if ((e.key === 'Enter' || e.key === ' ') && currentEmail.trim()) {
      e.preventDefault();
      if (currentEmail.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
        setEmail([...email, currentEmail.trim()]);
        setCurrentEmail('');
      } else {
        toast.error('Please enter a valid email address');
      }
    }
  };

  const removeEmail = (indexToRemove) => {
    setEmail(email.filter((_, index) => index !== indexToRemove));
  };

  // const handleSubmit = async(e) => {
  //   e.preventDefault();
  //   try {
  //     if (localStorage.token) {
  //       setAuthToken(localStorage.token);
  //     }

  //     const emailArray = Array.isArray(email) ? email : [email];
      
  //     const payload = {
  //       email: emailArray.filter(e => e),
  //       charter_id: charter_id,
  //       permaLink: permalink,
  //       learningCenters: name,
  //       siteId: id,
  //       pgPrimaryEmail: sendToParent,
  //       studentEmail: sendToStudent,
  //       LeloRegistrationProfile: courseid,
  //     };

  //     if (hasExistingData) {
  //       const response = await axios.put(
  //         `${appUrl}/api/leloEmailTemplate/${charter_id}/${courseid}/${id}`,
  //         payload,
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );
        
  //       if (response.data && response.data.email) {
  //         const updatedEmails = Array.isArray(response.data.email) 
  //           ? response.data.email 
  //           : response.data.email.split(',').map(e => e.trim());
  //         setEmail(updatedEmails);
  //       }
        
  //       alert("Email notification settings updated successfully!");
       
  //     } else {
  //       await axios.post(
  //         `${appUrl}/api/leloEmailTemplate`,
  //         payload,
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );   
  //       alert("Email notification setup saved successfully!");
        
  //     }
  //   } catch (error) {
  //     console.error("Error saving content:", error);
  //     const errorMessage =
  //       error.response?.data?.message ||
  //       error.message ||
  //       "An unexpected error occurred while saving";
  //     alert(`Error saving content: ${errorMessage}`);
  //   }
  // };

  const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    if (localStorage.token) {
      setAuthToken(localStorage.token);
    }

    const emailArray = Array.isArray(email) ? email : [email];
    const cleanedEmails = emailArray.filter(e => e); // remove falsy values

    const payload = {
      email: cleanedEmails,
      charter_id,
      permaLink: permalink,
      learningCenters: name,
      siteId: id,
      pgPrimaryEmail: sendToParent,
      studentEmail: sendToStudent,
      LeloRegistrationProfile: courseid,
    };

    if (hasExistingData) {
      const response = await axios.put(
        `${appUrl}/api/leloEmailTemplate/${charter_id}/${courseid}/${id}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data && response.data.email) {
        setEmail(
          Array.isArray(response.data.email)
            ? response.data.email
            : response.data.email.split(',').map(e => e.trim())
        );
      }

      toast.success("Email notification settings updated successfully!");
    } else {
      const response = await axios.post(
        `${appUrl}/api/leloEmailTemplate`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data && response.data.email) {
        setEmail(
          Array.isArray(response.data.email)
            ? response.data.email
            : response.data.email.split(',').map(e => e.trim())
        );
      }

      toast.success("Email notification setup saved successfully!");
    }
  } catch (error) {
    console.error("Error saving content:", error);
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "An unexpected error occurred while saving";
    toast.error(`Error saving content: ${errorMessage}`);
  }
};


  return (
    <div className={styles.contentWrapper}>
      <div className={styles.card}>
        <div className={styles.cardHeader}>
          <h5 className={styles.cardTitle}>Email Notification Settings</h5>
        </div>
        <div className={styles.cardBody}>
          <form onSubmit={handleSubmit}>
            <div className={styles.formGroup}>
              <label className={styles.label}>Send Notification</label>
              <div className={styles.emailList}>
                {email.map((emailItem, index) => (
                  <div key={index} className={styles.emailTag}>
                    {emailItem}
                    <button 
                      type="button" 
                      onClick={() => removeEmail(index)}
                      className={styles.deleteButton}
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
              <div className={styles.inputGroup}>
                <input
                  type="email"
                  className={styles.input}
                  placeholder="Enter email and press Space or Enter to add more."
                  value={currentEmail}
                  onChange={(e) => setCurrentEmail(e.target.value)}
                  onKeyDown={handleKeyDown}
                />
              </div>
            </div>

            <div className={styles.checkboxContainer}>
              <div className={styles.checkboxWrapper}>
                <input
                  type="checkbox"
                  className={styles.checkbox}
                  checked={sendToParent}
                  onChange={() => setSendToParent(!sendToParent)}
                  id="parentEmail"
                />
                <label htmlFor="parentEmail" className={styles.checkboxLabel}>
                  Send email to parent/guardian?
                </label>
              </div>

              <div className={styles.checkboxWrapper}>
                <input
                  type="checkbox"
                  className={styles.checkbox}
                  checked={sendToStudent}
                  onChange={() => setSendToStudent(!sendToStudent)}
                  id="studentEmail"
                />
                <label htmlFor="studentEmail" className={styles.checkboxLabel}>
                  Send email to student?
                </label>
              </div>
            </div>

            <div className={styles.cardFooter}>
              <button type="submit" className={styles.submitButton}>
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditEmailConfirmation;